import { Dispatch, ReactNode, SetStateAction, useState } from "react"

interface WizardComponentProps {
    stepController: [number, Dispatch<SetStateAction<number>>]
    children: ReactNode[]
}

function WizardComponent(props: WizardComponentProps) {
    const [currentStep, setCurrentStep] = props.stepController

    const [steps] = useState<number>(
        Array.isArray(props.children) ? props.children.length : 1
    )

    return (
        <div className={"w-full flex flex-col"}>
            <div className={"border-b pb-3 mb-3 text-sm"}>
                Schritt {currentStep + 1} von {steps}
            </div>
            <div className={"w-full"}>
                {Array.isArray(props.children)
                    ? props.children[currentStep]
                    : props.children}
            </div>
            <div
                className={
                    "border-t pt-3 mt-3 space-x-1 w-full flex justify-center"
                }>
                {Array(steps)
                    .fill(0)
                    .map((_, index: number) => (
                        <div
                            key={index}
                            className={
                                "h-2 w-2 rounded-full " +
                                (currentStep === index
                                    ? "bg-blue-600"
                                    : "bg-black opacity-15")
                            }
                        />
                    ))}
            </div>
        </div>
    )
}

export default WizardComponent
